(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var shelf_1 = require("./shelf");
var shelf_jquery_1 = require("./shelf-jquery");
$(function () {
    var shelf = new shelf_1.Shelf();
    shelf_jquery_1.setupJQuery(shelf);
    window.Shelf = shelf;
});
document.addEventListener("DOMContentLoaded", function () {
    $(document).on("keydown", ".shelf", function (event) {
        console.log("as");
        if (event.key === "Enter") {
            event.preventDefault();
            return false;
        }
        else {
            return;
        }
    });
});

},{"./shelf":3,"./shelf-jquery":2}],2:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Gets a new and unique id for a Shelf. The uniqueness is only guaranteed if you use this function for all of the Shelfs in the page.
 * It is recommended to either use this function for all Shelfs in a page or to assign them all ids manually, but never combine both
 * approaches, as it might result in different Shelfs having the same id.
 */
var getNewShelfId = (function () {
    var counter = 0;
    return function () {
        counter++;
        return counter.toString();
    };
})();
function setupJQuery(shelf) {
    var defaultOptions = {
        mode: "classic",
        take: 20,
        useUrlQuery: true,
    };
    $.fn.extend({
        /**
         * Create a new Shelf in the selected DOM with the given options.
         * @param options - Options to configure the Shelf. Example: {mode: '', url: '', take: 20}.
         */
        shelf: function (options) {
            var dom = $(this);
            if (options === undefined) {
                throw new Error("Must specify options");
            }
            function getOption(elem) {
                var res = options[elem] !== undefined ? options[elem] : dom.data(elem);
                return res === undefined ? defaultOptions[elem] : res;
            }
            // must-have options
            var resOptions = {
                mode: getOption("mode"),
                url: getOption("url"),
                id: getOption("id"),
                take: getOption("take"),
                useUrlQuery: getOption("useUrlQuery"),
            };
            if (!resOptions.id) {
                resOptions.id = getNewShelfId();
            }
            // add any extra option
            for (var key in options) {
                if (options.hasOwnProperty(key)) {
                    var element = options[key];
                    resOptions[key] = element;
                }
            }
            var ref = shelf.setup(dom, resOptions);
            var api = ref.api();
            return api;
        },
    });
}
exports.setupJQuery = setupJQuery;

},{}],3:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Shelf = /** @class */ (function () {
    function Shelf() {
        this.modes = {};
    }
    /**
     * Creates a GET action with the specified query to the url provided.
     * @param q - Query to send.
     * @param url - Url of the server.
     * @param success - Callback function that is called in case of success, data returned will be passed to success function as a parameter.
     * @param failure - Callback function that is called in case of failure, error occurred will be passed to failure function as a parameter.
     */
    Shelf.prototype.query = function (q, url, success, failure) {
        return $.getJSON(url, q)
            .done(function (json) {
            success(json);
        })
            .fail(function (jqxhr, textStatus, error) {
            failure(error);
        });
    };
    /**
     * Gets the inputs contained on a dom element. Attach extra elements to the inputs.
     * @param elem - DOM element where the inputs are contained.
     * @param extras - extra element to attach to the result.
     */
    Shelf.prototype.getInputs = function (elem, extras) {
        var q = $(elem).serializeArray();
        if (extras) {
            for (var p in extras) {
                if (extras.hasOwnProperty(p)) {
                    var found = false;
                    for (var _i = 0, q_1 = q; _i < q_1.length; _i++) {
                        var nvp = q_1[_i];
                        if (nvp["name"] === p) {
                            nvp["value"] = extras[p];
                            found = true;
                            break;
                        }
                    }
                    if (!found) {
                        q.push({ name: p, value: extras[p] });
                    }
                }
            }
        }
        return q;
    };
    Shelf.prototype.restoreInputs = function (form, state) {
        var els = $(form)
            .find(":input")
            .get();
        function inState(name, value) {
            if (Array.isArray(state[name])) {
                return state[name].some(function (v) { return v === value; });
            }
            else {
                return state[name] === value;
            }
        }
        $.each(els, function () {
            var name = this.getAttribute("name");
            var type = this.getAttribute("type");
            if (name) {
                if (type === "checkbox" || type === "radio") {
                    $(this).prop("checked", state[name] !== undefined && inState(name, $(this).val()));
                }
                else if (state[name]) {
                    $(this).val(state[name]); // this can also handle textarea and select elements
                }
            }
        });
    };
    /**
     * Gets the query part of the URL as an object.
     */
    Shelf.prototype.getUrlQuery = function () {
        var urlQuery = location.search.substring(1);
        urlQuery = '{"' + urlQuery.replace(/&/g, '","').replace(/=/g, '":"') + '"}';
        try {
            return JSON.parse(urlQuery, function (key, value) { return (key === "" ? value : decodeURIComponent(value)); });
        }
        catch (err) {
            return {};
        }
    };
    /**
     * Gets the query parameters of a specific Shelf from the URL. Given the id of a Shelf, returns an object containing the parameters of the query.
     * @param shelfId - The id of the Shelf.
     */
    Shelf.prototype.getUrlShelfQuery = function (shelfId) {
        var urlQuery = this.getUrlQuery();
        var jsonVal = urlQuery["shelf_" + shelfId];
        if (!jsonVal) {
            return undefined;
        }
        // decode from base64, then deserialize with json
        return JSON.parse(atob(jsonVal));
    };
    /**
     * Reflects the specified state of a Shelf in the URL.
     * @param shelfId - The id of the Shelf.
     * @param state - The state of the shelf (i.e. the query made).
     */
    Shelf.prototype.showStateInUrl = function (shelfId, state) {
        var urlQuery = this.getUrlQuery();
        // serialize with json, then encode to base64
        urlQuery["shelf_" + shelfId] = btoa(JSON.stringify(state));
        var url = location.protocol + "//" + location.host + location.pathname + "?" + $.param(urlQuery) + location.hash;
        window.history.replaceState(null, "", url);
    };
    /**
     * Register a new mode.
     * @param name - Name of the mode.
     * @param init - Init function of the mode.
     */
    Shelf.prototype.register = function (name, modeConstructor) {
        this.modes[name] = modeConstructor;
    };
    /**
     * Principal function of the Shelf, it setup the given DOM with the desired options to start working as a Shelf.
     * @param dom - Dom where the Shelf is contained.
     * @param options - Options of the Shelf.
     */
    Shelf.prototype.setup = function (dom, options) {
        var _this = this;
        var lastRequest;
        var mode = options.mode;
        var modeConstructor = this.modes[mode];
        var env = {
            query: function (q, success, failure) {
                if (lastRequest) {
                    lastRequest.abort();
                }
                lastRequest = _this.query(q, options.url, success, function (error) {
                    if (error !== "abort") {
                        failure(error);
                    }
                });
            },
            options: options,
        };
        return new modeConstructor(dom, env);
    };
    return Shelf;
}());
exports.Shelf = Shelf;

},{}]},{},[1])

//# sourceMappingURL=shelf.js.map
